// extracted by mini-css-extract-plugin
module.exports = {"container":"ip-z","recos":"jp-z","productCardOverride":"kp-z"};